/* eslint-disable */

/** unique or primary key constraints on table "argo.work_order_location" */
export enum ArgoWorkOrderLocationConstraint {
  /** unique or primary key constraint on columns "work_order_location_id" */
  WorkOrderLocationPkey = 'work_order_location_pkey',
  /** unique or primary key constraint on columns "location_id", "work_order_id" */
  WorkOrderLocationUnique = 'work_order_location_unique'
}

/** select columns of table "argo.work_order_location" */
export enum ArgoWorkOrderLocationSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** update columns of table "argo.work_order_location" */
export enum ArgoWorkOrderLocationUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkOrderId = 'work_order_id'
}

